import { useEffect, useState } from "react"
import { getCurrentAndNextWord, getNewActive } from "./common"

import { useKeyboard } from "./useKeyboard"

let makeEmptyMatrix = (size) => {
  return Array(size)
    .fill()
    .map(() =>
      Array(size)
        .fill()
        .map(() => ({
          x: null,
          y: null,
          disabled: true,
          char: null,
          dir: "",
          n: null,
          value: "",
        }))
    )
}

let makeMatrix = (size, entries) => {
  let m = makeEmptyMatrix(size)

  if (entries)
    entries.forEach((entry) => {
      m[entry.y][entry.x].n = entry.n

      if (entry.d === "A")
        [...entry.a.toUpperCase()].forEach((char, i) => {
          let y = entry.y,
            x = entry.x + i,
            cell = m[y][x]

          cell.x = x
          cell.y = y
          cell.dir += "→"
          cell.disabled = false
          cell.char = char
        })
      else
        [...entry.a.toUpperCase()].forEach((char, i) => {
          let y = entry.y + i,
            x = entry.x,
            cell = m[y][x]

          cell.x = x
          cell.y = y
          cell.dir += "↓"
          cell.disabled = false
          cell.char = char
        })
    })

  return m
}

export const flechitafy = (char) => (char === "A" ? "→" : "↓")

export const useCrosswordCells = (size, data, winCallback, debugMode) => {
  let [matrix, setMatrix] = useState(() => makeEmptyMatrix(size)),
    [active, setActive] = useState({ dir: "→", x: 0, y: 0 }),
    [progress, setProgress] = useState({ total: 0 }),
    [activeWrd, setActiveWrd] = useState({ dir: null, x: -1, y: -1, n: -1 })

  const wordAt = (x, y, d, len) => {
    let cells =
      flechitafy(d) === "→"
        ? matrix[y].slice(x, x + len)
        : matrix.slice(y, y + len).map((row) => row[x])

    return cells.map((c) => c.value).join("")
  }

  const onKeyInserted = () => {
    let total = data.length,
      dones = 0,
      prog = {}

    data.forEach((exp) => {
      // exp ~ { "x": 0, "y": 0, "d": "A", "c": "def...", a": "WHALE", "n": 1 }
      let key = [exp.x, exp.y, exp.d].join(),
        got = wordAt(exp.x, exp.y, exp.d, exp.a.length),
        done = got.toUpperCase() === exp.a.toUpperCase()

      dones += done
      prog[key] = done
    })

    prog["total"] = dones / total

    setProgress(prog)

    if (dones === total) winCallback()
  }

  useKeyboard(
    matrix,
    setMatrix,
    active,
    setActive,
    onKeyInserted,
    size,
    debugMode
  )

  useEffect(() => {
    setMatrix(() => makeMatrix(size, data))

    if (data && debugMode) setActive({ dir: "→", x: -1, y: -1 })
    else if (data && data.length) {
      setActive({
        dir: flechitafy(data[0].d),
        x: data[0].x,
        y: data[0].y,
      })
    }
  }, [size, data, debugMode])

  useEffect(() => {
    const ok = matrix.flat().some((x) => x.n !== null)
    if (!ok || debugMode) return
    const { current: nextCurrentWord } = getCurrentAndNextWord(matrix, active)
    setActiveWrd(nextCurrentWord)
  }, [matrix, active, debugMode])

  return {
    matrix,

    active,

    activeWrd,

    progress,

    handleClick(cell) {
      if (debugMode) return

      if (cell.disabled) return

      setActive(getNewActive(cell, active, size))
    },
  }
}
